/**
 * LayoutService - Device positioning utilities
 * 
 * Handles finding open positions for new devices on the canvas.
 */

// Default device dimensions for positioning calculations
const DEFAULT_DEVICE_WIDTH = 200;
const DEFAULT_DEVICE_HEIGHT = 150;
const DEFAULT_PADDING = 20;
const START_X = 50;
const START_Y = 50;
const MAX_COLS = 5;
const MAX_ATTEMPTS = 50;

/**
 * Find an open position for a new device on the canvas
 * @param {Object} instanceModel - The instance model with current devices
 * @param {Object} [options] - Optional positioning parameters
 * @param {number} [options.deviceWidth=200] - Width of device for collision detection
 * @param {number} [options.deviceHeight=150] - Height of device for collision detection
 * @param {number} [options.padding=20] - Space between devices
 * @returns {{ x: number, y: number }} Position object
 */
export function findOpenPosition(instanceModel, options = {}) {
    const deviceWidth = options.deviceWidth || DEFAULT_DEVICE_WIDTH;
    const deviceHeight = options.deviceHeight || DEFAULT_DEVICE_HEIGHT;
    const padding = options.padding || DEFAULT_PADDING;
    
    // Get all devices from the model
    const devices = instanceModel.getAll ? instanceModel.getAll() : instanceModel;
    
    for (let attempts = 0; attempts < MAX_ATTEMPTS; attempts++) {
        const col = attempts % MAX_COLS;
        const row = Math.floor(attempts / MAX_COLS);
        const x = START_X + col * (deviceWidth + padding);
        const y = START_Y + row * (deviceHeight + padding);
        
        const overlaps = devices.some(d => {
            const dx = Math.abs(d.position.x - x);
            const dy = Math.abs(d.position.y - y);
            return dx < deviceWidth && dy < deviceHeight;
        });
        
        if (!overlaps) {
            return { x, y };
        }
    }
    
    // Fallback: random position if grid is full
    return {
        x: START_X + Math.random() * 600,
        y: START_Y + Math.random() * 400
    };
}
